import { AfterViewInit, ChangeDetectionStrategy, Component, DestroyRef, Input, ViewChild, inject } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { TaskOverview } from '@apps/fiduciary/fiduciary.state';
import { Observable } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import moment from 'moment';
import { NavigationService } from '@platform/shared/navigation.service';
import { navigateNewWindowByUrl } from '@platform/shared/utilities/navigate.util';

@Component({
  selector: 'app-task-widget-table',
  templateUrl: './task-widget-table.component.html',
  styleUrls: ['./task-widget-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class TaskWidgetTableComponent implements AfterViewInit {
  @ViewChild(MatTable) table!: MatTable<TaskOverview>;
  @Input() tasks$: Observable<TaskOverview[]>;
  @Input() customerSpaceId: string;
  @Input() displayRowsCount = 6;
  dataSource = new MatTableDataSource<TaskOverview>([]);

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns = ['priority', 'title', 'dueOn'];

  private destroyRef = inject(DestroyRef);
  private navigation = inject(NavigationService);

  ngAfterViewInit(): void {
    this.tasks$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      this.dataSource = new MatTableDataSource(data.slice(0, this.displayRowsCount));
      this.table.dataSource = this.dataSource;
    });
  }

  public isOverdue(taskDate: Date): boolean {
    const dateTask = moment(taskDate);
    const datenNow = moment(new Date().setHours(0, 0, 0, 0));
    return moment(datenNow).isAfter(dateTask);
  }

  onRowClick(event: Event, task: TaskOverview) {
    event.preventDefault();
    if (task.source === 'Sharepoint') {
      if (!task.sharePointTaskUrl) {
        console.error(`${task.projectName} ${task.id} sharePointTaskUrl is not defined`);
        return;
      }
      navigateNewWindowByUrl(task.sharePointTaskUrl);
    } else {
      this.navigation.navigateTaskDetail(this.customerSpaceId, task.id);
    }
  }
}
